import { NgModule } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';

@NgModule({
  declarations: [],
  imports: [
    IonicStorageModule.forRoot({
      name: 'b2bAppStorageDb',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
  ],
  providers: [{ provide: 'LOCALSTORAGE', useFactory: getLocalStorage }],
})
export class StorageUtilLibModule {}

export function getLocalStorage() {
  return typeof window !== 'undefined' ? window.localStorage : null;
}
